import { render, staticRenderFns } from "./MF01.vue?vue&type=template&id=2a6bbb97&scoped=true"
import script from "./MF01.vue?vue&type=script&lang=js"
export * from "./MF01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bbb97",
  null
  
)

export default component.exports